export function FontSizeSmallerIcon({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 36 36" fill="none" className={className}>
      <path
        d="M20.7803 23.7803C20.921 23.6397 21 23.4489 21 23.25C21 23.0511 20.921 22.8603 20.7803 22.7197C20.6397 22.579 20.4489 22.5 20.25 22.5H15.75C15.5511 22.5 15.3603 22.579 15.2197 22.7197C15.079 22.8603 15 23.0511 15 23.25C15 23.4489 15.079 23.6397 15.2197 23.7803C15.3603 23.921 15.5511 24 15.75 24H20.25C20.4489 24 20.6397 23.921 20.7803 23.7803Z"
        fill="white"
      />
      <path
        d="M17.4697 23.7803C17.6103 23.921 17.8011 24 18 24C18.1989 24 18.3897 23.921 18.5303 23.7803C18.671 23.6397 18.75 23.4489 18.75 23.25L18.75 13.75C18.75 13.5511 18.671 13.3603 18.5303 13.2197C18.3897 13.079 18.1989 13 18 13C17.8011 13 17.6103 13.079 17.4697 13.2197C17.329 13.3603 17.25 13.5511 17.25 13.75L17.25 23.25C17.25 23.4489 17.329 23.6397 17.4697 23.7803Z"
        fill="white"
      />
      <path
        d="M23.7803 14.2803C23.921 14.1397 24 13.9489 24 13.75C24 13.5511 23.921 13.3603 23.7803 13.2197C23.6397 13.079 23.4489 13 23.25 13H12.75C12.5511 13 12.3603 13.079 12.2197 13.2197C12.079 13.3603 12 13.5511 12 13.75C12 13.9489 12.079 14.1397 12.2197 14.2803C12.3603 14.421 12.5511 14.5 12.75 14.5H23.25C23.4489 14.5 23.6397 14.421 23.7803 14.2803Z"
        fill="white"
      />
      <path
        d="M12.2197 15.7803C12.3603 15.921 12.5511 16 12.75 16C12.9489 16 13.1397 15.921 13.2803 15.7803C13.421 15.6397 13.5 15.4489 13.5 15.25L13.5 13.75C13.5 13.5511 13.421 13.3603 13.2803 13.2197C13.1397 13.079 12.9489 13 12.75 13C12.5511 13 12.3603 13.079 12.2197 13.2197C12.079 13.3603 12 13.5511 12 13.75L12 15.25C12 15.4489 12.079 15.6397 12.2197 15.7803Z"
        fill="white"
      />
      <path
        d="M22.7197 15.7803C22.8603 15.921 23.0511 16 23.25 16C23.4489 16 23.6397 15.921 23.7803 15.7803C23.921 15.6397 24 15.4489 24 15.25L24 13.75C24 13.5511 23.921 13.3603 23.7803 13.2197C23.6397 13.079 23.4489 13 23.25 13C23.0511 13 22.8603 13.079 22.7197 13.2197C22.579 13.3603 22.5 13.5511 22.5 13.75L22.5 15.25C22.5 15.4489 22.579 15.6397 22.7197 15.7803Z"
        fill="white"
      />
    </svg>
  )
}
